import LabelValueType from '../Models/LabelValueType';

export const PageSizing: LabelValueType[] = [
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
  { value: 250, label: '250' },
];
